import { ApiResourceMethod } from '@/api/api-requests-factory';
import { TagListItem, TagListRequestPayload } from '@/models/dictionary/tag-list.model';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';

export default class GetTagListRequest extends ApiResourceMethod<TagListItem[]> {
  public perform(params: TagListRequestPayload): Promise<TagListItem[]> {
    return this.performer.requestWithMapper(
      { params },
      ({ data }: BaseResponse<TagListItem[]>) => {
        return data;
      },
    );
  }
}
